module.exports = __webpack_public_path__ + "img/p2-img4-d2-2.2ac67cbd.png";